import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveAssetVehicleInfoinAllApplications } from '../../../AdminActionCreator.component';
import moment from 'moment';


const YearRange = 50;
const generateYearOptions = (range) => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = currentYear + range; i >= currentYear - range; i--) {
        years.push({ value: i.toString(), label: i.toString() });
    }

    return years;
};



const textFieldData = [
    { label: "Vehicle Type", value: "vehicleType", placeholder: "Select Vehicle Type", type: "text", name: "vehicleType" },
    { label: "Make", value: "make", placeholder: "Enter Make", type: "text", name: "make" },
    { label: "Make Class", value: "makeClass", placeholder: "Enter Make Class", type: "text", name: "makeClass" },
    { label: "Variant", value: "variant", placeholder: "Enter Variant", type: "text", name: "variant" },
    { label: "Manufacture Year", value: "manufactureYear", placeholder: "Enter Manufacture Year", type: "year", name: "manufactureYear" },
    { label: "Registration Date", value: "registrationDate", placeholder: "Enter Registration Date", type: "date", name: "registrationDate" },
    { label: "Battery Type", value: "batteryType", placeholder: "Enter Battery Type", type: "text", name: "batteryType" },
    { label: "Battery Warranty(In Months)", value: "batteryWarranty", placeholder: "Enter Battery Warranty", type: "number", name: "batteryWarranty" },
    { label: "Motor Power", value: "motorPower", placeholder: "Enter Motor Power", type: "number", name: "motorPower" },
    { label: "Battery Voltage", value: "batteryVoltage", placeholder: "Enter Battery Voltage", type: "number", name: "batteryVoltage" },
    { label: "Capacity", value: "capacity", placeholder: "Enter Capacity", type: "number", name: "capacity" },
    { label: "Vehicle Weight", value: "vehicleWeight", placeholder: "Enter Vehicle Weight", type: "number", name: "vehicleWeight" },
    { label: "Invoice Amount", value: "invoiceAmount", placeholder: "Enter Invoice Amount", type: "number", name: "invoiceAmount" },
    { label: "Battery OEMId", value: "batteryOemId", placeholder: "Enter Battery OEMId", type: "text", name: "batteryOemId" },
]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup,admin }) {
    const [yearsFuncitonData, setYearsFunctionData] = useState(generateYearOptions(YearRange))
    const [objectData, setObjectData] = useState({
        "vehicleType": "",
        "make": "",
        "makeClass": "",
        "variant": "",
        "manufactureYear": "",
        "registrationDate": "",
        "batteryType": "",
        "batteryWarranty": "",
        "motorPower": "",
        "batteryVoltage": "",
        "capacity": "",
        "vehicleWeight": "",
        "invoiceAmount": "",
        "batteryOemId": "",
    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data,moment(data?.assetAndVehicleDetailPO?.registrationDate).format("YYYY-MM-DD"))
        if (data?.userId) {
            setObjectData({
                "vehicleType": data?.assetAndVehicleDetailPO?.vehicleType || "",
                "make": data?.assetAndVehicleDetailPO?.make || "",
                "makeClass": data?.assetAndVehicleDetailPO?.makeClass || "",
                "variant": data?.assetAndVehicleDetailPO?.variant || "",
                "manufactureYear": data?.assetAndVehicleDetailPO?.manufactureYear || "",
                "registrationDate": moment(data?.assetAndVehicleDetailPO?.registrationDate, "DD-MM-YYYY").format("YYYY-MM-DD") || "",
                "batteryType": data?.assetAndVehicleDetailPO?.batteryType || "",
                "batteryWarranty": data?.assetAndVehicleDetailPO?.batteryWarranty || "",
                "motorPower": data?.assetAndVehicleDetailPO?.motorPower || "",
                "batteryVoltage": data?.assetAndVehicleDetailPO?.batteryVoltage || "",
                "capacity": data?.assetAndVehicleDetailPO?.capacity || "",
                "vehicleWeight": data?.assetAndVehicleDetailPO?.vehicleWeight || "",
                "invoiceAmount": data?.assetAndVehicleDetailPO?.invoiceAmount || "",
                "batteryOemId": data?.assetAndVehicleDetailPO?.batteryOemId || "",
            })
        } else {
            setObjectData({
                "vehicleType": "",
                "make": "",
                "makeClass": "",
                "variant": "",
                "manufactureYear": "",
                "registrationDate": "",
                "batteryType": "",
                "batteryWarranty": "",
                "motorPower": "",
                "batteryVoltage": "",
                "capacity": "",
                "vehicleWeight": "",
                "invoiceAmount": "",
                "batteryOemId": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId, applicationId: null,
            "formStatus":"update",
              "empId":admin?.emailId,
              "registrationDate":moment(objectData.registrationDate)?.format("DD-MM-YYYY")
         }
        handleLoader(true)
        SaveAssetVehicleInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Asset & Vehicle Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Asset & Vehicle Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Assets & Vehicle Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "manufactureYear" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "manufactureYear" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {yearsFuncitonData && yearsFuncitonData?.length > 0 ? yearsFuncitonData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        )) : ''}
                                                    </TextField>

                                                    :
                                                    ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
